import {
  Utensils, UtensilsCrossed, Pizza, Sandwich, Beef, Fish, Coffee, Beer, Wine,
  IceCream, Cake, Croissant, Apple, Carrot, Soup, Salad, EggFried,
  ShoppingCart, ShoppingBag, ShoppingBasket, Store, Pill, Cross, Stethoscope,
  HeartPulse, Syringe, Activity, Dumbbell, Bike, Scissors, Sparkles, Shirt,
  Footprints, Watch, Gem, Glasses, Hammer, Wrench, Drill, Ruler, HardHat,
  PaintRoller, Sofa, Bed, BedDouble, Lamp, Refrigerator, WashingMachine, Tv,
  Laptop, Smartphone, Cpu, Monitor, Printer, Camera, Car, CarFront, Bus, Truck,
  Fuel, GraduationCap, BookOpen, School, Pencil, Calculator, Scale, Briefcase,
  Gavel, PartyPopper, Music, Plane, Hotel, Mountain, MapPin, Dog, Cat, Bird,
  PawPrint, Wheat, Tractor, Sprout, Leaf, Flower2, TreePine, Home, Building2,
  Warehouse, Key, Package, Gift, Ticket, Tag, Percent, CreditCard, Wallet,
  Phone, Baby, Palette, Bell, Star, Heart, Zap, Droplet, Flame, Sun, Gamepad2,
  Grid3x3, Smile, Stamp, Bone, Shield,
} from "lucide-react";

// key = stored value (existing categories keep working); kw = pt-BR search keywords
const ICONS = [
  { key: "utensils", C: Utensils, kw: "restaurante comida alimentacao garfo faca refeicao" },
  { key: "utensils-crossed", C: UtensilsCrossed, kw: "restaurante comida talheres refeicao cozinha" },
  { key: "pizza", C: Pizza, kw: "pizza pizzaria" },
  { key: "sandwich", C: Sandwich, kw: "lanche lanchonete sanduiche hamburguer x-burguer" },
  { key: "beef", C: Beef, kw: "carne churrasco espetinho hamburguer" },
  { key: "fish", C: Fish, kw: "peixe frutos do mar pescado" },
  { key: "coffee", C: Coffee, kw: "cafe cafeteria bebida quente" },
  { key: "beer", C: Beer, kw: "bebida cerveja bar distribuidora" },
  { key: "wine", C: Wine, kw: "bebida vinho adega bar" },
  { key: "ice-cream", C: IceCream, kw: "sorvete sorveteria acai doce gelado" },
  { key: "cake", C: Cake, kw: "bolo doce confeitaria festa aniversario" },
  { key: "croissant", C: Croissant, kw: "padaria paes croissant" },
  { key: "apple", C: Apple, kw: "fruta hortifruti alimentacao saudavel" },
  { key: "carrot", C: Carrot, kw: "hortifruti verdura legume feira" },
  { key: "soup", C: Soup, kw: "sopa caldo restaurante comida" },
  { key: "salad", C: Salad, kw: "salada saudavel natural comida fit" },
  { key: "egg-fried", C: EggFried, kw: "cafe da manha ovo lanche comida" },
  { key: "shopping-cart", C: ShoppingCart, kw: "mercado supermercado compras carrinho mercearia" },
  { key: "shopping-bag", C: ShoppingBag, kw: "loja compras sacola comercio varejo" },
  { key: "shopping-basket", C: ShoppingBasket, kw: "mercado cesta compras feira mercearia" },
  { key: "store", C: Store, kw: "loja comercio estabelecimento ponto comercial" },
  { key: "pill", C: Pill, kw: "farmacia remedio medicamento drogaria saude" },
  { key: "cross", C: Cross, kw: "saude farmacia clinica hospital posto" },
  { key: "stethoscope", C: Stethoscope, kw: "saude medico clinica consultorio" },
  { key: "heart-pulse", C: HeartPulse, kw: "saude clinica hospital cardiologia" },
  { key: "syringe", C: Syringe, kw: "saude vacina clinica injecao odontologia" },
  { key: "activity", C: Activity, kw: "saude exames laboratorio clinica" },
  { key: "tooth", C: Smile, kw: "odontologia dentista dente sorriso clinica" },
  { key: "dumbbell", C: Dumbbell, kw: "academia musculacao ginastica fitness personal" },
  { key: "bike", C: Bike, kw: "moto bicicleta bike ciclismo delivery" },
  { key: "scissors", C: Scissors, kw: "salao cabeleireiro barbearia beleza corte" },
  { key: "sparkles", C: Sparkles, kw: "beleza estetica limpeza brilho salao" },
  { key: "shirt", C: Shirt, kw: "roupa moda vestuario camisa loja" },
  { key: "footprints", C: Footprints, kw: "calcados sapato tenis loja" },
  { key: "watch", C: Watch, kw: "acessorios relogio joalheria" },
  { key: "gem", C: Gem, kw: "joalheria acessorios joias semijoias" },
  { key: "glasses", C: Glasses, kw: "otica oculos acessorios" },
  { key: "hammer", C: Hammer, kw: "construcao ferramenta reforma obra material" },
  { key: "wrench", C: Wrench, kw: "oficina conserto ferramenta manutencao mecanica" },
  { key: "drill", C: Drill, kw: "construcao ferramenta furadeira reforma" },
  { key: "ruler", C: Ruler, kw: "construcao medida projeto arquitetura reforma" },
  { key: "hard-hat", C: HardHat, kw: "construcao obra engenharia pedreiro capacete" },
  { key: "paint-roller", C: PaintRoller, kw: "pintura tinta construcao reforma pintor" },
  { key: "sofa", C: Sofa, kw: "moveis sofa estofado decoracao casa" },
  { key: "bed", C: Bed, kw: "moveis cama colchao quarto" },
  { key: "bed-double", C: BedDouble, kw: "hotel pousada quarto cama hospedagem imovel" },
  { key: "lamp", C: Lamp, kw: "iluminacao luminaria eletrica decoracao" },
  { key: "refrigerator", C: Refrigerator, kw: "eletrodomestico geladeira eletro casa" },
  { key: "washing-machine", C: WashingMachine, kw: "eletrodomestico maquina lavar lavanderia eletro" },
  { key: "tv", C: Tv, kw: "eletronico televisao tv eletro" },
  { key: "laptop", C: Laptop, kw: "informatica computador notebook laptop" },
  { key: "smartphone", C: Smartphone, kw: "celular telefone smartphone assistencia tecnica" },
  { key: "cpu", C: Cpu, kw: "informatica computador processador tecnologia" },
  { key: "monitor", C: Monitor, kw: "informatica computador monitor tela" },
  { key: "printer", C: Printer, kw: "informatica impressora grafica copias" },
  { key: "camera", C: Camera, kw: "fotografia foto camera estudio filmagem" },
  { key: "car", C: Car, kw: "veiculo carro automovel autopecas revenda" },
  { key: "car-front", C: CarFront, kw: "veiculo carro automovel oficina lava jato" },
  { key: "bus", C: Bus, kw: "transporte onibus viagem excursao" },
  { key: "truck", C: Truck, kw: "transporte frete caminhao entrega mudanca" },
  { key: "fuel", C: Fuel, kw: "combustivel posto gasolina" },
  { key: "graduation-cap", C: GraduationCap, kw: "educacao escola faculdade formatura ensino" },
  { key: "book-open", C: BookOpen, kw: "educacao curso livraria estudo aula" },
  { key: "school", C: School, kw: "educacao escola creche colegio ensino" },
  { key: "pencil", C: Pencil, kw: "educacao papelaria escola material escolar" },
  { key: "calculator", C: Calculator, kw: "contabilidade contador financas escritorio" },
  { key: "scale", C: Scale, kw: "advocacia advogado juridico direito balanca" },
  { key: "briefcase", C: Briefcase, kw: "servicos emprego trabalho vagas negocios" },
  { key: "gavel", C: Gavel, kw: "advocacia advogado juridico leilao direito" },
  { key: "party-popper", C: PartyPopper, kw: "festa evento comemoracao aniversario buffet" },
  { key: "music", C: Music, kw: "musica evento som dj banda festa" },
  { key: "plane", C: Plane, kw: "turismo viagem agencia passagem aviao" },
  { key: "hotel", C: Hotel, kw: "hotel pousada hospedagem turismo" },
  { key: "mountain", C: Mountain, kw: "turismo ponto turistico natureza trilha serra" },
  { key: "map-pin", C: MapPin, kw: "local endereco mapa ponto turistico localizacao" },
  { key: "dog", C: Dog, kw: "pet petshop cachorro animal veterinario" },
  { key: "cat", C: Cat, kw: "pet petshop gato animal veterinario" },
  { key: "bird", C: Bird, kw: "pet passaro animal petshop" },
  { key: "paw", C: PawPrint, kw: "pet petshop animal patinha veterinario" },
  { key: "wheat", C: Wheat, kw: "agricultura agro trigo graos rural fazenda" },
  { key: "tractor", C: Tractor, kw: "agricultura agro trator rural fazenda maquina" },
  { key: "sprout", C: Sprout, kw: "agricultura muda planta jardim horta agro" },
  { key: "leaf", C: Leaf, kw: "natureza jardim planta ecologico agro" },
  { key: "flower", C: Flower2, kw: "floricultura flores jardim decoracao presente" },
  { key: "tree", C: TreePine, kw: "natureza arvore jardim paisagismo turismo" },
  { key: "home", C: Home, kw: "casa imovel aluguel moradia residencia" },
  { key: "building", C: Building2, kw: "imovel predio comercio empresa ponto comercial" },
  { key: "warehouse", C: Warehouse, kw: "galpao deposito imovel ponto comercial armazem" },
  { key: "key", C: Key, kw: "imovel aluguel chave imobiliaria casa" },
  { key: "package", C: Package, kw: "entrega delivery encomenda pacote logistica" },
  { key: "gift", C: Gift, kw: "presente loja festa brinde" },
  { key: "ticket", C: Ticket, kw: "cupom desconto ingresso evento voucher" },
  { key: "tag", C: Tag, kw: "promocao oferta preco etiqueta desconto" },
  { key: "percent", C: Percent, kw: "desconto promocao porcentagem oferta" },
  { key: "credit-card", C: CreditCard, kw: "pagamento cartao financas servicos" },
  { key: "wallet", C: Wallet, kw: "financas carteira dinheiro pagamento" },
  { key: "phone", C: Phone, kw: "telefone contato servicos telefonia" },
  { key: "baby", C: Baby, kw: "bebe infantil crianca maternidade loja" },
  { key: "palette", C: Palette, kw: "arte pintura design tinta beleza" },
  { key: "bell", C: Bell, kw: "servicos aviso notificacao" },
  { key: "star", C: Star, kw: "destaque favorito estrela" },
  { key: "heart", C: Heart, kw: "favorito amor saude" },
  { key: "zap", C: Zap, kw: "eletrica energia eletricista servicos" },
  { key: "droplet", C: Droplet, kw: "agua encanador hidraulica limpeza servicos" },
  { key: "flame", C: Flame, kw: "gas churrasco fogo botijao" },
  { key: "sun", C: Sun, kw: "energia solar clima turismo" },
  { key: "gamepad", C: Gamepad2, kw: "games jogos lan house eletronico diversao" },
  { key: "stamp", C: Stamp, kw: "cartorio servicos documentos autenticacao" },
  { key: "bone", C: Bone, kw: "pet petshop osso cachorro animal" },
  { key: "shield", C: Shield, kw: "seguranca seguro servicos protecao" },
  { key: "grid", C: Grid3x3, kw: "outros geral categorias diversos" },
];

export const ICON_LIBRARY = ICONS.reduce((acc, i) => { acc[i.key] = i.C; return acc; }, {});
export const ICON_LIST = ICONS.map((i) => ({ name: i.key, keywords: i.kw }));
export const ICON_NAMES = ICONS.map((i) => i.key);

export const CategoryIcon = ({ name, className }) => {
  const Cmp = ICON_LIBRARY[name] || Grid3x3;
  return <Cmp className={className} />;
};
